var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable } from 'mobx';
import Model from './Model';
import ProviderData from '../data/ProviderData';
var FeedModel = /** @class */ (function (_super) {
    __extends(FeedModel, _super);
    function FeedModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param data
     */
    FeedModel.prototype.update = function (data) {
        var _this = this;
        if (!data)
            return;
        var keys = Object.keys(data);
        keys.map(function (key) {
            switch (key) {
                case 'lastProcessedSnapshotTimestamp':
                case 'lastRefreshTimestamp':
                case 'createdTimestamp':
                case 'lastModifiedTimestamp':
                    _this[key] = data[key] > 0 ? new Date(data[key]) : null;
                    break;
                default:
                    _this[key] = data[key];
            }
        });
    };
    /**
     *
     */
    FeedModel.prototype.hasUrgentStatus = function () {
        switch (this.status) {
            case 1:
            case 'None':
            case 2:
            case 'Error':
                return true;
        }
        return false;
    };
    /**
     *
     * @return {string}
     */
    FeedModel.prototype.getStatusType = function () {
        switch (this.status) {
            case 0:
            case 'Ok':
                return 'success';
            case 1:
            case 'None':
                return 'warning';
            case 2:
            case 'Error':
                return 'danger';
        }
        return 'primary';
    };
    /**
     *
     * @return {null}
     */
    FeedModel.prototype.getProvider = function () {
        var _this = this;
        if (this.providerName != null) {
            var selectedProvider = ProviderData.find(function (data) {
                return data.provider === _this.providerName && data.feedDataType.name === _this.dataType;
            });
            return selectedProvider ? selectedProvider : null;
        }
        return null;
    };
    /**
     *
     * @param intl
     * @return {string | React.ReactNodeArray | *|*}
     */
    FeedModel.prototype.getStatusMessage = function (intl) {
        if (this.statusMessage && this.statusMessage.length > 0) {
            return this.statusMessage;
        }
        return intl.formatMessage({ id: 'feed.status.default.' + this.getStatusType() });
    };
    __decorate([
        observable
    ], FeedModel.prototype, "id", void 0);
    __decorate([
        observable
    ], FeedModel.prototype, "url", void 0);
    __decorate([
        observable
    ], FeedModel.prototype, "username", void 0);
    __decorate([
        observable
    ], FeedModel.prototype, "password", void 0);
    __decorate([
        observable
    ], FeedModel.prototype, "providerName", void 0);
    __decorate([
        observable
    ], FeedModel.prototype, "dataType", void 0);
    __decorate([
        observable
    ], FeedModel.prototype, "status", void 0);
    __decorate([
        observable
    ], FeedModel.prototype, "organisationId", void 0);
    __decorate([
        observable
    ], FeedModel.prototype, "refreshInSeconds", void 0);
    __decorate([
        observable
    ], FeedModel.prototype, "isEnabled", void 0);
    __decorate([
        observable
    ], FeedModel.prototype, "statusMessage", void 0);
    __decorate([
        observable
    ], FeedModel.prototype, "lastProcessedSnapshotTimestamp", void 0);
    __decorate([
        observable
    ], FeedModel.prototype, "lastRefreshTimestamp", void 0);
    __decorate([
        observable
    ], FeedModel.prototype, "createdTimestamp", void 0);
    __decorate([
        observable
    ], FeedModel.prototype, "lastModifiedTimestamp", void 0);
    return FeedModel;
}(Model));
export default FeedModel;
